// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__6hEe3","inner":"Form_inner__3cP1h","range":"Form_range__bxciY","name":"Form_name__2z68A","actions":"Form_actions__1iQmG"};